'use client';

import { useEffect } from 'react';

type CookiebotInitProps = {
  cbid?: string;
};

export default function CookiebotInit({ cbid }: CookiebotInitProps) {
  useEffect(() => {
    // No-op when no consent id is configured (e.g. local dev), during SSR,
    // or if the script has already been injected.
    if (!cbid || typeof window === 'undefined' || document.getElementById('Cookiebot')) {
      return;
    }

    const script = document.createElement('script');
    script.id = 'Cookiebot';
    script.src = 'https://consent.cookiebot.com/uc.js';
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('data-cbid', cbid);
    script.setAttribute('data-blockingmode', 'auto');

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [cbid]);

  return null;
}
